import Vue from 'vue';
import Vuex from 'vuex';
import getNested from 'lodash-es/get';

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getVesselsInArea(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/inarea',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getLadenState(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/laden_state',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async getTopCountries(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/top_countries',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getTopRegions(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/top_regions',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getTopPorts(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/top_ports',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getVoyageState(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/voyage_state',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getVesselSegments(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/vessel_segments',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getVessels(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/vessels',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getVesselsCount(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/vessel_count',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async getTimeseries(store, data) {
      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/livestates/timeseries',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        {root: true},
      );
    },
  },
};
